import { render, staticRenderFns } from "./roleMenu.vue?vue&type=template&id=22f25020&"
import script from "./roleMenu.vue?vue&type=script&lang=js&"
export * from "./roleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports